export default "__VITE_ASSET__OdntCsnQ__"